// components/BlogList.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBlogs,
  deleteBlog,
  setBlogPagination,
} from "../redux/slices/blogslice";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";

const BlogList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { blogs, pagination, loading } = useSelector((state) => state.blogs);

  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchBlogs({ search, page: pagination.page, limit: pagination.limit }));
  }, [dispatch, search, pagination.page, pagination.limit]);

  const handlePageChange = (page) => {
    dispatch(setBlogPagination({ page }));
  };

  const handleEdit = (blogId) => {
    navigate(`/edit-blog/${blogId}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      dispatch(deleteBlog(id));
    }
  };

  console.log("blogs", blogs)

  return (
    <div className="card shadow-sm">
      {/* Card Header */}
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">Blogs</h5>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search blogs..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Card Body */}
      <div className="card-body p-0">
        {loading ? (
          <div className="p-3">Loading...</div>
        ) : blogs.length === 0 ? (
          <div className="p-3">No blogs found.</div>
        ) : (
          <table className="table table-hover mb-0">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Blog Image</th>
                <th>Title</th>
                <th>Category</th>
                <th>Views</th>
                <th>Created</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((blog, index) => (
                <tr key={blog._id}>
                  <td>{(pagination.page - 1) * pagination.limit + index + 1}</td>
                  <td>
                    <img src={blog.image} alt={blog.blogTitle} width={100} height={100} />
                  </td>
                  <td>{blog.blogTitle}</td>
                  <td>{blog.category?.name || "N/A"}</td>
                  <td>{blog.views}</td>
                  <td>{moment(blog.createdAt).format('DD/MM/YYYY')}</td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEdit(blog.blogId)}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(blog._id)}
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      {pagination.totalPages > 1 && (
        <div className="card-footer d-flex justify-content-center">
          <nav>
            <ul className="pagination mb-0">
              {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <li
                    key={page}
                    className={`page-item ${pagination.page === page ? "active" : ""
                      }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  </li>
                )
              )}
            </ul>
          </nav>
        </div>
      )}
    </div>
  );
};

export default BlogList;
